import React from "react";

export const ConditionalLink = ({
  href,
  onClick,
  children,
  linkClassName,
}: {
  href?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
  children: React.ReactNode;
  shouldNotRenderChildren?: boolean;
  linkClassName?: string;
}) => {
  if (!href) {
    return <>{children}</>;
  }

  return (
    <a
      className={linkClassName}
      href={href}
      target="_blank"
      rel="noopener"
      onClick={onClick}
    >
      {children}
    </a>
  );
};
